// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"50bf695d","493":"9366b48a","547":"c21b4077","639":"504633a0","710":"c270ed79"}[chunkId] + ".chunk.css";
};